import React from 'react';
import { Accordion } from '@mantine/core';

import Header from './DivisionsHeader';
import ProcurementManagerCard from './ProcurementManagerCard';
import { Manager } from '../../codegen/graphql';

type Props = {
    managers: Manager[];
};

function ProcurementManagers({ managers }: Props) {
    return (
        <>
            <Header isProcurement />
            <Accordion
                multiple
                classNames={{
                    control:
                        'flex border-solid border-l-3 border-primary shadow-md mt-2 h-[64px] bg-white pl-0',
                    content: 'px-1',
                    item: 'border-none',
                }}
            >
                {managers.map(manager => (
                    <ProcurementManagerCard
                        key={manager.id}
                        manager={manager}
                    />
                ))}
            </Accordion>
        </>
    );
}

export default ProcurementManagers;
